// How a post's status is said and coloured.
//
// One map, because the Posts screen and the dashboard's recent-posts card both
// answer the same question and two copies would eventually disagree about what
// "partially_published" is called in front of a customer.

import type { Post } from "./types";

/** The `.chip` modifier for a status — "" is the neutral chip. */
export const STATUS_CHIP: Record<Post["status"], string> = {
  draft: "", scheduled: "busy", publishing: "busy",
  published: "ok", partially_published: "warn", failed: "err",
};

export const STATUS_LABEL: Record<Post["status"], string> = {
  draft: "Draft", scheduled: "Scheduled", publishing: "Publishing",
  published: "Published", partially_published: "Partly published", failed: "Failed",
};
